@if (loaded) {
  <div class="modal-content">
    <div class="modal-header bg-tertiary">
      <h6 class="modal-title fw-bold" id="addConfigurationModalLabel">{{ isCreate() ? 'Create' : 'Edit' }} {{ type }}</h6>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" id="form" (ngSubmit)="onSubmit()">
        <div class="row mb-3">
          <div class="col-md-12 mb-3">
            <label for="subject" class="form-label fw-bold small small">Subject</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-pencil-square"></i></span>
              <input type="text" class="form-control" id="subject" placeholder="Enter subject" formControlName="subject">
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <label for="message" class="form-label fw-bold small small">Message</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-pencil-square"></i></span>
              <textarea class="form-control" id="message" rows="4" placeholder="Enter your message" formControlName="message"></textarea>
            </div>
          </div>
          <div class="mb-3 d-flex align-items-center">
            <label class="form-label fw-bold small me-4">Pinned:</label>
            <div>
              <div class="form-check form-check-inline">
                <input formControlName="pinned" class="form-check-input" type="radio" name="pinned" id="pinned-true" [value]=true>
                <label class="form-check-label" for="pinned-true">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input formControlName="pinned" class="form-check-input" type="radio" name="pinned" id="pinned-false" [value]=false>
                <label class="form-check-label" for="pinned-false">No</label>
              </div>
            </div>
          </div>
          <div class="mb-3 d-flex align-items-center">
            <label for="recipientId" class="form-label fw-bold small me-4">Recipient:</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person"></i></span>
              <select formControlName="recipientId" class="form-select" id="recipientId">
                <option [value]="connectedUser.id">MYSELF</option>
                @for (user of users; track user) {
                  <option [value]="user.id">{{ user.firstname }}</option>
                }
              </select>
            </div>
          </div>
          @if (type === 'task') {
            <div class="mb-3">
              <label for="occurring-date" class="form-label fw-bold small">Date:</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-calendar-event"></i></span>
                <input formControlName="occurringDate" type="date" class="form-control" id="occurring-date">
                <input formControlName="occurringTime" type="time" class="form-control" id="occurring-time" value="00:00" style="max-width:100px;">
                <select formControlName="repeatFrequency" class="form-select" style="max-width:100px;">
                  <option [value]=null selected="">Repeat</option>
                  <option value="daily">Every day</option>
                  <option value="weekly">Every week</option>
                  <option value="monthly">Every month</option>
                  <option value="yearly">Every year</option>
                </select>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="form-check">
                <input [(ngModel)]="hasAlert" [ngModelOptions]="{standalone: true}" class="form-check-input" type="checkbox" id="alert">
                <label class="form-check-label fw-bold small me-4" for="alert">Receive an alert:</label>
              </div>
              @if (hasAlert) {
                <div class="input-group" style="width:250px;">
                  <span class="input-group-text"><i class="bi bi-bell"></i></span>
                  <select formControlName="alertTime" id="alert-time" class="form-select">
                    <option [value]=null>When</option>
                    <option value="same_day">The same day</option>
                    <option value="one_day_before">1 day before</option>
                    <option value="two_day_before">2 days before</option>
                    <option value="one_week_before">1 week before</option>
                  </select>
                </div>
              }
            </div>
          }
        </div>
      </form>
    </div>
    <div class="modal-footer bg-tertiary">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
      <button form="form" type="submit" class="btn btn-primary fw-bold">
        {{ isCreate() ? 'Create' : 'Update' }}
      </button>
    </div>
  </div>
}
